module.exports = __webpack_public_path__ + "img/home_menu_transport120.f45e45e5.png";